import { jsx as _jsx } from "react/jsx-runtime";
export default function Level(_a) {
    var level = _a.level, type = _a.type, _b = _a.width, width = _b === void 0 ? 40 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c;
    var img = type === 'charm'
        ? "https://img.danachatapp.com/charm_icon/charm_charm-".concat(level, ".png")
        : "https://img.danachatapp.com/wealth_icon/wealth_wealth-".concat(level, ".png");
    if (type === 'noble') {
        img = "https://img.danachatapp.com/vip/vip_little_vip_little_".concat(level, ".png");
    }
    return (_jsx("div", { className: "bg-cover", style: { backgroundImage: "url(".concat(img, ")"), width: type === 'noble' ? 48 : 40, height: height } }));
}
